import React from 'react';
import { Card, CardContent } from './ui/card';
import { features } from '../data/mockData';
import { Zap, Shield, TrendingUp, Users, BarChart3, Clock } from 'lucide-react';

const iconMap = {
  Zap,
  Shield,
  TrendingUp,
  Users,
  BarChart3,
  Clock,
};

const Features = () => {
  return (
    <section id="solutions" className="py-24 bg-[#101F27] relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#009688] to-transparent opacity-50"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-base md:text-lg font-semibold text-[#009688] uppercase tracking-wide mb-4">
            Complete Solution
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Everything You Need to{' '}
            <span className="text-white">
              Go Cashless
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Mobile POS + Cashless Payments + Real-Time Analytics. Turn-key solution ready in 24 hours.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <Card
                key={index}
                className="bg-[#37464F]/50 border-gray-800 hover:border-[#009688]/50 transition-all duration-300 hover:shadow-xl hover:shadow-[#009688]/10 group"
              >
                <CardContent className="p-8">
                  <div className="mb-6 inline-flex p-4 bg-gradient-to-br from-[#009688]/10 to-[#005B4F]/10 rounded-xl group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8 text-[#009688]" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
                  <p className="text-gray-400 leading-relaxed">{feature.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-400 mb-6">
            Want to see how it all works together?
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('demo');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-[#009688] font-semibold hover:underline"
          >
            See how it works
          </button>
        </div>
      </div>
    </section>
  );
};

export default Features;
